import gsap from 'gsap'
import { useRef } from 'react'

import { useGSAP } from '@gsap/react'

import { TouchIndicatorWrapper } from './TouchIndicator.styles'

interface TouchIndicatorProps {
  label?: string
}

const TouchIndicator = ({ label }: TouchIndicatorProps) => {
  const svgRef = useRef<SVGSVGElement | null>(null)

  useGSAP(() => {
    if (!svgRef.current) return
    const paths = svgRef.current.querySelectorAll('path')
    const timeline = gsap.timeline({ repeat: -1, repeatDelay: 0.5 })
    gsap.set(paths, { drawSVG: '0%' })

    timeline.to(paths, { drawSVG: '100%', duration: 1, stagger: 0.1 })
    timeline.to(paths, { opacity: 0, duration: 0.1 }, '>2.5')
  })

  return (
    <TouchIndicatorWrapper>
      <svg ref={svgRef} viewBox="0 0 72 83" fill="none">
        <path d="M12 9.5C15.1667 7 24.9 2.1 36.5 2.5C48.1 2.9 56.5 7.33334 59.5 9.5" strokeWidth="4" strokeLinecap="round" />
        <path d="M2 30C5.5 24 17.2 12.2 36 13C54.8 13.8 66.5 24.6667 70 30" strokeWidth="4" strokeLinecap="round" />
        <path
          d="M65 67C67 61 69.8 47.1 65 39.5C59 30 50.5 22 34 22.5C17.5 23 7.49995 37 5.99995 44.5C4.49995 52 3.91912 59.4762 12.5 62C21 64.5 25.1993 57.6065 26 50C27 40.5 41.5001 40 45.5 47C50.0741 55.0048 45.4999 77 22.9999 81"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path
          d="M14.5 52.5C15.1667 45.1667 20.5 30.9 36.5 32.5C56.5 34.5 60 52 56.5 61C53.7 68.2 47.6667 76 45 79"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path d="M36 53.5C36.1667 56.3333 33.7 64.4 28.5 68C23.6656 71.3469 17 72 11 71.5" strokeWidth="4" strokeLinecap="round" />
      </svg>
      <span>{label}</span>
    </TouchIndicatorWrapper>
  )
}

export default TouchIndicator
